// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --sidebar-width: 240px;
    --sidebar-collapsed-width: 70px;
    --header-height: 85px;
    --primary-color: #f7bd20;
    --primary-gradient: linear-gradient(135deg, #f7bd20, #ffd700);
    --dark-bg: #1a1a1a;
    --darker-bg: #0f0f0f;
    --light-bg: #f8f9fa;
    --text-primary: #1a1a1a;
    --text-secondary: #64748b;
    --border-color: rgba(247, 189, 32, 0.15);
    --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.04);
    --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.08);
    --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.12);
    --shadow-xl: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.dashboard-container {
    display: flex;
    min-height: 100vh;
    background: linear-gradient(135deg, #ffffff 0%, #fffdf2 50%, #fffbea 100%);
    position: relative;
    overflow: hidden;
}

.dashboard-container::before {
    content: '';
    position: absolute;
    top: -10%;
    right: -5%;
    width: 700px;
    height: 700px;
    background: radial-gradient(circle, rgba(247, 189, 32, 0.08) 0%, transparent 70%);
    border-radius: 50%;
    pointer-events: none;
    z-index: 0;
}

.dashboard-container::after {
    content: '';
    position: absolute;
    bottom: 5%;
    left: 10%;
    width: 500px;
    height: 500px;
    background: radial-gradient(circle, rgba(247, 189, 32, 0.05) 0%, transparent 70%);
    border-radius: 50%;
    pointer-events: none;
    z-index: 0;
}

/* Refined Sidebar Styling */
.dashboard-sidebar {
    width: 240px;
    width: var(--sidebar-width);
    background: #ffffff;
    border-right: 1px solid #edf2f7;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    transition: all 0.3s ease;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.02);
}

.sidebar-brand {
    padding: 0.5rem 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #f7fafc;
}

.collapse-toggle {
    position: absolute;
    right: -12px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    background: #f7bd20;
    background: var(--primary-color);
    border: none;
    border-radius: 50%;
    color: #1a1a1a;
    color: var(--dark-bg);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    font-size: 0.7rem;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.collapse-toggle:hover {
    transform: translateY(-50%) scale(1.15);
    background: #fff;
}

.sidebar-logo {
    height: 140px;
    width: auto;
    object-fit: contain;
    transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.sidebar-logo:hover {
    transform: scale(1.05);
    filter: drop-shadow(0 6px 12px rgba(247, 189, 32, 0.5));
}

.sidebar-nav {
    flex: 1 1;
    padding: 2rem 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.nav-item {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    padding: 1.1rem 1.5rem;
    border-radius: 14px;
    color: #64748b;
    color: var(--text-secondary);
    text-decoration: none;
    font-weight: 600;
    font-size: 0.95rem;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
}

.nav-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 4px;
    background: linear-gradient(135deg, #f7bd20, #ffd700);
    background: var(--primary-gradient);
    transform: scaleY(0);
    transition: transform 0.3s ease;
}

.nav-item:hover {
    background: rgba(247, 189, 32, 0.08);
    color: #f7bd20;
    color: var(--primary-color);
    transform: translateX(4px);
    box-shadow: 0 4px 12px rgba(247, 189, 32, 0.15);
}

.nav-item:hover::before {
    transform: scaleY(1);
}

.nav-item.active {
    background: linear-gradient(135deg, #f7bd20, #ffd700);
    background: var(--primary-gradient);
    color: #000;
    font-weight: 700;
    box-shadow: 0 6px 20px rgba(247, 189, 32, 0.4);
    transform: translateX(2px);
}

.nav-item.active::before {
    transform: scaleY(1);
}

.nav-icon {
    font-size: 1.35rem;
    transition: transform 0.3s ease;
}

.nav-item:hover .nav-icon,
.nav-item.active .nav-icon {
    transform: scale(1.15);
}

/* Collapsed Sidebar States */
.dashboard-sidebar.collapsed {
    width: 70px;
    width: var(--sidebar-collapsed-width);
}

.dashboard-sidebar.collapsed .sidebar-logo {
    height: 50px;
}

.dashboard-sidebar.collapsed .nav-label,
.dashboard-sidebar.collapsed .sidebar-footer .nav-label {
    display: none;
}

.dashboard-sidebar.collapsed .nav-item {
    justify-content: center;
    padding: 1.1rem 0;
    margin: 0 0.5rem;
}

.dashboard-sidebar.collapsed .nav-icon {
    font-size: 1.5rem;
}

.dashboard-sidebar.collapsed .sidebar-logout-btn {
    justify-content: center;
    padding: 1rem 0;
}

.dashboard-wrapper {
    flex: 1 1;
    margin-left: 240px;
    margin-left: var(--sidebar-width);
    display: flex;
    flex-direction: column;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.dashboard-wrapper.collapsed {
    margin-left: 70px;
    margin-left: var(--sidebar-collapsed-width);
}

.sidebar-footer {
    padding: 1.5rem;
    border-top: 1px solid rgba(247, 189, 32, 0.15);
    border-top: 1px solid var(--border-color);
}

.sidebar-logout-btn {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem 1.25rem;
    border-radius: 12px;
    background: rgba(239, 68, 68, 0.08);
    border: 1px solid rgba(239, 68, 68, 0.2);
    color: #ef4444;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
}

.sidebar-logout-btn:hover {
    background: rgba(239, 68, 68, 0.15);
    border-color: #ef4444;
}

/* Refined Header Styling */
.dashboard-header-new {
    height: 85px;
    height: var(--header-height);
    background: rgba(255, 255, 255, 0.8);
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
    border-bottom: 1px solid #edf2f7;
    padding: 0 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 999;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 2rem;
}

.mobile-toggle {
    display: none;
    font-size: 1.75rem;
    background: #f8f9fa;
    background: var(--light-bg);
    border: none;
    cursor: pointer;
    width: 45px;
    height: 45px;
    border-radius: 12px;
    transition: all 0.3s ease;
}

.mobile-toggle:hover {
    background: rgba(247, 189, 32, 0.15);
    background: var(--border-color);
    transform: scale(1.05);
}

.page-title {
    font-size: 2rem;
    font-weight: 900;
    color: #1a1a1a;
    margin: 0;
    letter-spacing: -1.5px;
    background: linear-gradient(135deg, #1a1a1a 30%, #f7bd20 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.header-right {
    position: relative;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.header-btn {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: linear-gradient(135deg, #f8f9fa, #fff);
    background: linear-gradient(135deg, var(--light-bg), #fff);
    border: 2px solid rgba(247, 189, 32, 0.15);
    border: 2px solid var(--border-color);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    font-size: 1.3rem;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    box-shadow: var(--shadow-sm);
}

.header-btn:hover {
    background: linear-gradient(135deg, #f7bd20, #ffd700);
    background: linear-gradient(135deg, var(--primary-color), #ffd700);
    border-color: #f7bd20;
    border-color: var(--primary-color);
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    box-shadow: var(--shadow-md);
}

.badge {
    position: absolute;
    top: -4px;
    right: -4px;
    background: linear-gradient(135deg, #ef4444, #dc2626);
    color: #fff;
    font-size: 0.7rem;
    font-weight: 800;
    padding: 0.25rem 0.5rem;
    border-radius: 12px;
    border: 3px solid #fff;
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {

    0%,
    100% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.1);
    }
}

.header-profile-btn {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.5rem 1rem;
    border-radius: 30px;
    background-color: #f8f9fa;
    background-color: var(--light-bg);
    border: 1px solid rgba(247, 189, 32, 0.15);
    border: 1px solid var(--border-color);
    cursor: pointer;
    transition: all 0.2s ease;
}

.header-profile-btn:hover {
    border-color: #f7bd20;
    border-color: var(--primary-color);
}

.avatar {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background: linear-gradient(135deg, #f7bd20, #f5a623);
    background: linear-gradient(135deg, var(--primary-color), #f5a623);
    color: #1a1a1a;
    color: var(--dark-bg);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 0.9rem;
}

.name-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.user-name {
    font-size: 0.9rem;
    font-weight: 600;
    color: #1a1a1a;
    color: var(--text-primary);
}

.user-role {
    font-size: 0.75rem;
    color: #64748b;
    color: var(--text-secondary);
}

.header-dropdown {
    position: absolute;
    top: calc(100% + 15px);
    right: 0;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.15);
    width: 350px;
    overflow: hidden;
    animation: dropdownAnim 0.3s ease;
    border: 1px solid rgba(247, 189, 32, 0.15);
    border: 1px solid var(--border-color);
}

@keyframes dropdownAnim {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.notifications-dropdown .dropdown-header {
    padding: 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(247, 189, 32, 0.15);
    border-bottom: 1px solid var(--border-color);
}

.notifications-dropdown h3 {
    margin: 0;
    font-size: 1.1rem;
}

.clear-all {
    background: none;
    border: none;
    color: #f7bd20;
    color: var(--primary-color);
    font-weight: 600;
    cursor: pointer;
}

.dropdown-list {
    max-height: 400px;
    overflow-y: auto;
}

.dropdown-item {
    padding: 1.25rem 1.5rem;
    display: flex;
    gap: 1rem;
    border-bottom: 1px solid rgba(247, 189, 32, 0.15);
    border-bottom: 1px solid var(--border-color);
    cursor: pointer;
}

.dropdown-item:hover {
    background-color: #f8f9fa;
    background-color: var(--light-bg);
}

.dropdown-item.unread {
    background-color: rgba(247, 189, 32, 0.03);
}

.item-icon {
    font-size: 1.5rem;
    flex-shrink: 0;
}

.item-body h4 {
    margin: 0 0 0.25rem;
    font-size: 0.95rem;
    font-weight: 600;
}

.item-body p {
    margin: 0 0 0.5rem;
    font-size: 0.85rem;
    color: #64748b;
    color: var(--text-secondary);
    line-height: 1.4;
}

.item-body .time {
    font-size: 0.75rem;
    color: #999;
}

.profile-dropdown {
    width: 280px;
}

.profile-top {
    padding: 2rem;
    background-color: #f8f9fa;
    background-color: var(--light-bg);
    text-align: center;
}

.avatar-large {
    width: 60px;
    height: 60px;
    margin: 0 auto 1rem;
    border-radius: 50%;
    background: linear-gradient(135deg, #f7bd20, #f5a623);
    background: linear-gradient(135deg, var(--primary-color), #f5a623);
    color: #1a1a1a;
    color: var(--dark-bg);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    font-weight: 700;
}

.profile-top h4 {
    margin: 0 0 0.25rem;
    font-size: 1.1rem;
}

.profile-top p {
    margin: 0;
    font-size: 0.85rem;
    color: #64748b;
    color: var(--text-secondary);
}

.profile-menu {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.menu-item {
    padding: 0.75rem 1rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    border-radius: 10px;
    color: #1a1a1a;
    color: var(--text-primary);
    text-decoration: none;
    font-weight: 500;
    transition: all 0.2s ease;
    border: none;
    background: none;
    width: 100%;
    cursor: pointer;
}

.menu-item:hover {
    background-color: #f8f9fa;
    background-color: var(--light-bg);
    color: #f7bd20;
    color: var(--primary-color);
}

.dashboard-content-new {
    padding: 3rem;
    flex: 1 1;
    background: transparent;
    min-height: calc(100vh - 85px);
    min-height: calc(100vh - var(--header-height));
}

.dashboard-content-new>*+* {
    margin-top: 2rem;
}

.sidebar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 998;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
}

.modal-content {
    background: #fff;
    padding: 2.5rem;
    border-radius: 24px;
    max-width: 450px;
    width: 90%;
    text-align: center;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.4);
}

.modal-icon {
    font-size: 3.5rem;
    margin-bottom: 1rem;
}

.modal-actions {
    display: flex;
    gap: 1rem;
    margin-top: 2.5rem;
}

.modal-btn {
    flex: 1 1;
    padding: 1rem;
    border-radius: 12px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    transition: 0.3s;
}

.modal-btn.cancel {
    background: #f8f9fa;
    background: var(--light-bg);
    color: #1a1a1a;
    color: var(--text-primary);
}

.modal-btn.confirm {
    background: #ef4444;
    color: #fff;
}

/* Responsive Overhaul */
@media (max-width: 1024px) {
    .dashboard-sidebar {
        transform: translateX(-100%);
        width: 280px;
        left: 0;
    }

    .dashboard-sidebar.mobile-open {
        transform: translateX(0);
    }

    .dashboard-wrapper {
        margin-left: 0 !important;
    }

    .mobile-toggle {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .page-title {
        font-size: 1.25rem;
    }

    .dashboard-header-new {
        padding: 0 1.5rem;
    }
}

@media (max-width: 768px) {
    .dashboard-header-new {
        height: 70px;
        padding: 0 1rem;
    }

    .name-info {
        display: none;
    }

    .dashboard-content-new {
        padding: 1.25rem;
        padding-bottom: 90px;
    }

    .header-btn {
        width: 42px;
        height: 42px;
        font-size: 1.2rem;
    }

    .header-dropdown {
        width: calc(100vw - 2rem);
        right: -1rem;
        position: fixed;
        top: 75px;
        left: 1rem;
    }

    .mobile-bottom-nav {
        display: flex !important;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fff;
        height: 72px;
        border-top: 1px solid rgba(247, 189, 32, 0.15);
        border-top: 1px solid var(--border-color);
        z-index: 1001;
        padding: 0 0.5rem;
        justify-content: space-around;
        align-items: center;
        box-shadow: 0 -4px 25px rgba(0, 0, 0, 0.12);
    }

    .bottom-nav-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        text-decoration: none;
        color: #64748b;
        color: var(--text-secondary);
        font-size: 0.65rem;
        font-weight: 600;
        flex: 1 1;
        text-align: center;
    }

    .bottom-nav-item .nav-icon {
        font-size: 1.5rem;
        margin-bottom: 2px;
    }

    .bottom-nav-item.active {
        color: #f7bd20;
        color: var(--primary-color);
    }

    .modal-content {
        padding: 1.5rem;
    }
}

/* Table Responsiveness Utility */
@media (max-width: 900px) {

    .disbursement-table,
    .responsive-table {
        border: none !important;
    }

    .disbursement-table .table-header,
    .responsive-table .table-header {
        display: none !important;
    }

    .disbursement-table .table-row,
    .responsive-table .table-row {
        grid-template-columns: 1fr !important;
        padding: 1.5rem !important;
        margin-bottom: 1.5rem;
        border: 1px solid rgba(247, 189, 32, 0.15) !important;
        border: 1px solid var(--border-color) !important;
        border-radius: 20px !important;
        background: #fff !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        box-shadow: var(--shadow-sm);
    }

    .disbursement-table .table-cell,
    .responsive-table .table-cell {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.8rem 0 !important;
        border-bottom: 1px solid #f0f0f0 !important;
    }

    .disbursement-table .table-cell:last-child {
        border-bottom: none !important;
    }

    .disbursement-table .cell-label {
        display: block !important;
        font-weight: 700;
        font-size: 0.7rem;
        color: #999;
        text-transform: uppercase;
    }

    .disbursement-table .cell-value {
        font-weight: 600;
        font-size: 0.95rem;
    }
}

.mobile-bottom-nav {
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/DashboardLayout.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,+BAA+B;IAC/B,qBAAqB;IACrB,wBAAwB;IACxB,6DAA6D;IAC7D,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,wCAAwC;IACxC,0CAA0C;IAC1C,2CAA2C;IAC3C,2CAA2C;IAC3C,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,0EAA0E;IAC1E,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa;IACb,iFAAiF;IACjF,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,aAAa;IACb,iFAAiF;IACjF,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;AACd;;AAEA,4BAA4B;AAC5B;IACI,YAA2B;IAA3B,2BAA2B;IAC3B,mBAAmB;IACnB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,aAAa;IACb,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,mBAAgC;IAAhC,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;IAClB,cAAqB;IAArB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,wCAAwC;IACxC,iBAAiB;IACjB,iDAAiD;AACrD;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,kEAAkE;AACtE;;AAEA;IACI,sBAAsB;IACtB,uDAAuD;AAC3D;;AAEA;IACI,SAAO;IACP,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,cAA4B;IAA5B,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,iDAAiD;IACjD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,UAAU;IACV,qDAAmC;IAAnC,mCAAmC;IACnC,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA;IACI,oCAAoC;IACpC,cAA2B;IAA3B,2BAA2B;IAC3B,0BAA0B;IAC1B,+CAA+C;AACnD;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qDAAmC;IAAnC,mCAAmC;IACnC,WAAW;IACX,gBAAgB;IAChB,8CAA8C;IAC9C,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA,6BAA6B;AAC7B;IACI,WAAqC;IAArC,qCAAqC;AACzC;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,kBAAiC;IAAjC,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,iDAAiD;AACrD;;AAEA;IACI,iBAA2C;IAA3C,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,8CAAyC;IAAzC,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,mBAAmB;IACnB,mCAAmC;IACnC,wCAAwC;IACxC,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA,2BAA2B;AAC3B;IACI,YAA4B;IAA5B,4BAA4B;IAC5B,oCAAoC;IACpC,mCAA2B;YAA3B,2BAA2B;IAC3B,gCAAgC;IAChC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wBAAgB;IAAhB,gBAAgB;IAChB,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAA2B;IAA3B,2BAA2B;IAC3B,YAAY;IACZ,eAAe;IACf,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,oCAA+B;IAA/B,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,sBAAsB;IACtB,8DAA8D;IAC9D,6BAA6B;IAC7B,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kDAA0D;IAA1D,0DAA0D;IAC1D,0CAAqC;IAArC,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iDAAiD;IACjD,yCAA4B;IAA5B,4BAA4B;AAChC;;AAEA;IACI,qDAAkE;IAAlE,kEAAkE;IAClE,qBAAkC;IAAlC,kCAAkC;IAClC,uCAAuC;IACvC,0CAA4B;IAA5B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,qDAAqD;IACrD,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,6CAA6C;IAC7C,wCAAwC;AAC5C;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,mBAAmB;IACnB,yBAAiC;IAAjC,iCAAiC;IACjC,0CAAqC;IAArC,qCAAqC;IACrC,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qBAAkC;IAAlC,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAkE;IAAlE,kEAAkE;IAClE,cAAqB;IAArB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,cAA4B;IAA5B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,YAAY;IACZ,gBAAgB;IAChB,iCAAiC;IACjC,0CAAqC;IAArC,qCAAqC;AACzC;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iDAA4C;IAA5C,4CAA4C;AAChD;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAA2B;IAA3B,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,SAAS;IACT,iDAA4C;IAA5C,4CAA4C;IAC5C,eAAe;AACnB;;AAEA;IACI,yBAAiC;IAAjC,iCAAiC;AACrC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAA4B;IAA5B,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAiC;IAAjC,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,qDAAkE;IAAlE,kEAAkE;IAClE,cAAqB;IAArB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAA4B;IAA5B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,cAA0B;IAA1B,0BAA0B;IAC1B,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAiC;IAAjC,iCAAiC;IACjC,cAA2B;IAA3B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,SAAO;IACP,uBAAuB;IACvB,8BAA8C;IAA9C,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,cAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA,wBAAwB;AACxB;IACI;QACI,4BAA4B;QAC5B,YAAY;QACZ,OAAO;IACX;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,eAAe;QACf,SAAS;QACT,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,eAAe;QACf,SAAS;QACT,OAAO;QACP,QAAQ;QACR,gBAAgB;QAChB,YAAY;QACZ,8CAAyC;QAAzC,yCAAyC;QACzC,aAAa;QACb,iBAAiB;QACjB,6BAA6B;QAC7B,mBAAmB;QACnB,2CAA2C;IAC/C;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,QAAQ;QACR,qBAAqB;QACrB,cAA4B;QAA5B,4BAA4B;QAC5B,kBAAkB;QAClB,gBAAgB;QAChB,SAAO;QACP,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,cAA2B;QAA3B,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,iCAAiC;AACjC;;IAEI;;QAEI,uBAAuB;IAC3B;;IAEA;;QAEI,wBAAwB;IAC5B;;IAEA;;QAEI,qCAAqC;QACrC,0BAA0B;QAC1B,qBAAqB;QACrB,qDAAgD;QAAhD,gDAAgD;QAChD,8BAA8B;QAC9B,2BAA2B;QAC3B,yCAA4B;QAA5B,4BAA4B;IAChC;;IAEA;;QAEI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,4BAA4B;QAC5B,2CAA2C;IAC/C;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,iBAAiB;QACjB,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;IACI,aAAa;AACjB","sourcesContent":[":root {\n    --sidebar-width: 240px;\n    --sidebar-collapsed-width: 70px;\n    --header-height: 85px;\n    --primary-color: #f7bd20;\n    --primary-gradient: linear-gradient(135deg, #f7bd20, #ffd700);\n    --dark-bg: #1a1a1a;\n    --darker-bg: #0f0f0f;\n    --light-bg: #f8f9fa;\n    --text-primary: #1a1a1a;\n    --text-secondary: #64748b;\n    --border-color: rgba(247, 189, 32, 0.15);\n    --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.04);\n    --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.08);\n    --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.12);\n    --shadow-xl: 0 12px 40px rgba(0, 0, 0, 0.15);\n}\n\n.dashboard-container {\n    display: flex;\n    min-height: 100vh;\n    background: linear-gradient(135deg, #ffffff 0%, #fffdf2 50%, #fffbea 100%);\n    position: relative;\n    overflow: hidden;\n}\n\n.dashboard-container::before {\n    content: '';\n    position: absolute;\n    top: -10%;\n    right: -5%;\n    width: 700px;\n    height: 700px;\n    background: radial-gradient(circle, rgba(247, 189, 32, 0.08) 0%, transparent 70%);\n    border-radius: 50%;\n    pointer-events: none;\n    z-index: 0;\n}\n\n.dashboard-container::after {\n    content: '';\n    position: absolute;\n    bottom: 5%;\n    left: 10%;\n    width: 500px;\n    height: 500px;\n    background: radial-gradient(circle, rgba(247, 189, 32, 0.05) 0%, transparent 70%);\n    border-radius: 50%;\n    pointer-events: none;\n    z-index: 0;\n}\n\n/* Refined Sidebar Styling */\n.dashboard-sidebar {\n    width: var(--sidebar-width);\n    background: #ffffff;\n    border-right: 1px solid #edf2f7;\n    display: flex;\n    flex-direction: column;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1000;\n    transition: all 0.3s ease;\n    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.02);\n}\n\n.sidebar-brand {\n    padding: 0.5rem 1rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-bottom: 1px solid #f7fafc;\n}\n\n.collapse-toggle {\n    position: absolute;\n    right: -12px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 24px;\n    height: 24px;\n    background: var(--primary-color);\n    border: none;\n    border-radius: 50%;\n    color: var(--dark-bg);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    z-index: 10;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    font-size: 0.7rem;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.collapse-toggle:hover {\n    transform: translateY(-50%) scale(1.15);\n    background: #fff;\n}\n\n.sidebar-logo {\n    height: 140px;\n    width: auto;\n    object-fit: contain;\n    transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n.sidebar-logo:hover {\n    transform: scale(1.05);\n    filter: drop-shadow(0 6px 12px rgba(247, 189, 32, 0.5));\n}\n\n.sidebar-nav {\n    flex: 1;\n    padding: 2rem 1.25rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.nav-item {\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n    padding: 1.1rem 1.5rem;\n    border-radius: 14px;\n    color: var(--text-secondary);\n    text-decoration: none;\n    font-weight: 600;\n    font-size: 0.95rem;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n    overflow: hidden;\n}\n\n.nav-item::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 4px;\n    background: var(--primary-gradient);\n    transform: scaleY(0);\n    transition: transform 0.3s ease;\n}\n\n.nav-item:hover {\n    background: rgba(247, 189, 32, 0.08);\n    color: var(--primary-color);\n    transform: translateX(4px);\n    box-shadow: 0 4px 12px rgba(247, 189, 32, 0.15);\n}\n\n.nav-item:hover::before {\n    transform: scaleY(1);\n}\n\n.nav-item.active {\n    background: var(--primary-gradient);\n    color: #000;\n    font-weight: 700;\n    box-shadow: 0 6px 20px rgba(247, 189, 32, 0.4);\n    transform: translateX(2px);\n}\n\n.nav-item.active::before {\n    transform: scaleY(1);\n}\n\n.nav-icon {\n    font-size: 1.35rem;\n    transition: transform 0.3s ease;\n}\n\n.nav-item:hover .nav-icon,\n.nav-item.active .nav-icon {\n    transform: scale(1.15);\n}\n\n/* Collapsed Sidebar States */\n.dashboard-sidebar.collapsed {\n    width: var(--sidebar-collapsed-width);\n}\n\n.dashboard-sidebar.collapsed .sidebar-logo {\n    height: 50px;\n}\n\n.dashboard-sidebar.collapsed .nav-label,\n.dashboard-sidebar.collapsed .sidebar-footer .nav-label {\n    display: none;\n}\n\n.dashboard-sidebar.collapsed .nav-item {\n    justify-content: center;\n    padding: 1.1rem 0;\n    margin: 0 0.5rem;\n}\n\n.dashboard-sidebar.collapsed .nav-icon {\n    font-size: 1.5rem;\n}\n\n.dashboard-sidebar.collapsed .sidebar-logout-btn {\n    justify-content: center;\n    padding: 1rem 0;\n}\n\n.dashboard-wrapper {\n    flex: 1;\n    margin-left: var(--sidebar-width);\n    display: flex;\n    flex-direction: column;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.dashboard-wrapper.collapsed {\n    margin-left: var(--sidebar-collapsed-width);\n}\n\n.sidebar-footer {\n    padding: 1.5rem;\n    border-top: 1px solid var(--border-color);\n}\n\n.sidebar-logout-btn {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    padding: 1rem 1.25rem;\n    border-radius: 12px;\n    background: rgba(239, 68, 68, 0.08);\n    border: 1px solid rgba(239, 68, 68, 0.2);\n    color: #ef4444;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.sidebar-logout-btn:hover {\n    background: rgba(239, 68, 68, 0.15);\n    border-color: #ef4444;\n}\n\n/* Refined Header Styling */\n.dashboard-header-new {\n    height: var(--header-height);\n    background: rgba(255, 255, 255, 0.8);\n    backdrop-filter: blur(10px);\n    border-bottom: 1px solid #edf2f7;\n    padding: 0 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: sticky;\n    top: 0;\n    z-index: 999;\n}\n\n.header-left {\n    display: flex;\n    align-items: center;\n    gap: 2rem;\n}\n\n.mobile-toggle {\n    display: none;\n    font-size: 1.75rem;\n    background: var(--light-bg);\n    border: none;\n    cursor: pointer;\n    width: 45px;\n    height: 45px;\n    border-radius: 12px;\n    transition: all 0.3s ease;\n}\n\n.mobile-toggle:hover {\n    background: var(--border-color);\n    transform: scale(1.05);\n}\n\n.page-title {\n    font-size: 2rem;\n    font-weight: 900;\n    color: #1a1a1a;\n    margin: 0;\n    letter-spacing: -1.5px;\n    background: linear-gradient(135deg, #1a1a1a 30%, #f7bd20 100%);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n.header-right {\n    position: relative;\n}\n\n.header-actions {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.header-btn {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, var(--light-bg), #fff);\n    border: 2px solid var(--border-color);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    position: relative;\n    font-size: 1.3rem;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    box-shadow: var(--shadow-sm);\n}\n\n.header-btn:hover {\n    background: linear-gradient(135deg, var(--primary-color), #ffd700);\n    border-color: var(--primary-color);\n    transform: translateY(-2px) scale(1.05);\n    box-shadow: var(--shadow-md);\n}\n\n.badge {\n    position: absolute;\n    top: -4px;\n    right: -4px;\n    background: linear-gradient(135deg, #ef4444, #dc2626);\n    color: #fff;\n    font-size: 0.7rem;\n    font-weight: 800;\n    padding: 0.25rem 0.5rem;\n    border-radius: 12px;\n    border: 3px solid #fff;\n    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);\n    animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n\n    0%,\n    100% {\n        transform: scale(1);\n    }\n\n    50% {\n        transform: scale(1.1);\n    }\n}\n\n.header-profile-btn {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    padding: 0.5rem 1rem;\n    border-radius: 30px;\n    background-color: var(--light-bg);\n    border: 1px solid var(--border-color);\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.header-profile-btn:hover {\n    border-color: var(--primary-color);\n}\n\n.avatar {\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, var(--primary-color), #f5a623);\n    color: var(--dark-bg);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    font-size: 0.9rem;\n}\n\n.name-info {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.user-name {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.user-role {\n    font-size: 0.75rem;\n    color: var(--text-secondary);\n}\n\n.header-dropdown {\n    position: absolute;\n    top: calc(100% + 15px);\n    right: 0;\n    background: #fff;\n    border-radius: 20px;\n    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.15);\n    width: 350px;\n    overflow: hidden;\n    animation: dropdownAnim 0.3s ease;\n    border: 1px solid var(--border-color);\n}\n\n@keyframes dropdownAnim {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.notifications-dropdown .dropdown-header {\n    padding: 1.5rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid var(--border-color);\n}\n\n.notifications-dropdown h3 {\n    margin: 0;\n    font-size: 1.1rem;\n}\n\n.clear-all {\n    background: none;\n    border: none;\n    color: var(--primary-color);\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.dropdown-list {\n    max-height: 400px;\n    overflow-y: auto;\n}\n\n.dropdown-item {\n    padding: 1.25rem 1.5rem;\n    display: flex;\n    gap: 1rem;\n    border-bottom: 1px solid var(--border-color);\n    cursor: pointer;\n}\n\n.dropdown-item:hover {\n    background-color: var(--light-bg);\n}\n\n.dropdown-item.unread {\n    background-color: rgba(247, 189, 32, 0.03);\n}\n\n.item-icon {\n    font-size: 1.5rem;\n    flex-shrink: 0;\n}\n\n.item-body h4 {\n    margin: 0 0 0.25rem;\n    font-size: 0.95rem;\n    font-weight: 600;\n}\n\n.item-body p {\n    margin: 0 0 0.5rem;\n    font-size: 0.85rem;\n    color: var(--text-secondary);\n    line-height: 1.4;\n}\n\n.item-body .time {\n    font-size: 0.75rem;\n    color: #999;\n}\n\n.profile-dropdown {\n    width: 280px;\n}\n\n.profile-top {\n    padding: 2rem;\n    background-color: var(--light-bg);\n    text-align: center;\n}\n\n.avatar-large {\n    width: 60px;\n    height: 60px;\n    margin: 0 auto 1rem;\n    border-radius: 50%;\n    background: linear-gradient(135deg, var(--primary-color), #f5a623);\n    color: var(--dark-bg);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.5rem;\n    font-weight: 700;\n}\n\n.profile-top h4 {\n    margin: 0 0 0.25rem;\n    font-size: 1.1rem;\n}\n\n.profile-top p {\n    margin: 0;\n    font-size: 0.85rem;\n    color: var(--text-secondary);\n}\n\n.profile-menu {\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.menu-item {\n    padding: 0.75rem 1rem;\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    border-radius: 10px;\n    color: var(--text-primary);\n    text-decoration: none;\n    font-weight: 500;\n    transition: all 0.2s ease;\n    border: none;\n    background: none;\n    width: 100%;\n    cursor: pointer;\n}\n\n.menu-item:hover {\n    background-color: var(--light-bg);\n    color: var(--primary-color);\n}\n\n.dashboard-content-new {\n    padding: 3rem;\n    flex: 1;\n    background: transparent;\n    min-height: calc(100vh - var(--header-height));\n}\n\n.dashboard-content-new>*+* {\n    margin-top: 2rem;\n}\n\n.sidebar-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 998;\n}\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.7);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2000;\n}\n\n.modal-content {\n    background: #fff;\n    padding: 2.5rem;\n    border-radius: 24px;\n    max-width: 450px;\n    width: 90%;\n    text-align: center;\n    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.4);\n}\n\n.modal-icon {\n    font-size: 3.5rem;\n    margin-bottom: 1rem;\n}\n\n.modal-actions {\n    display: flex;\n    gap: 1rem;\n    margin-top: 2.5rem;\n}\n\n.modal-btn {\n    flex: 1;\n    padding: 1rem;\n    border-radius: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    border: none;\n    transition: 0.3s;\n}\n\n.modal-btn.cancel {\n    background: var(--light-bg);\n    color: var(--text-primary);\n}\n\n.modal-btn.confirm {\n    background: #ef4444;\n    color: #fff;\n}\n\n/* Responsive Overhaul */\n@media (max-width: 1024px) {\n    .dashboard-sidebar {\n        transform: translateX(-100%);\n        width: 280px;\n        left: 0;\n    }\n\n    .dashboard-sidebar.mobile-open {\n        transform: translateX(0);\n    }\n\n    .dashboard-wrapper {\n        margin-left: 0 !important;\n    }\n\n    .mobile-toggle {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .page-title {\n        font-size: 1.25rem;\n    }\n\n    .dashboard-header-new {\n        padding: 0 1.5rem;\n    }\n}\n\n@media (max-width: 768px) {\n    .dashboard-header-new {\n        height: 70px;\n        padding: 0 1rem;\n    }\n\n    .name-info {\n        display: none;\n    }\n\n    .dashboard-content-new {\n        padding: 1.25rem;\n        padding-bottom: 90px;\n    }\n\n    .header-btn {\n        width: 42px;\n        height: 42px;\n        font-size: 1.2rem;\n    }\n\n    .header-dropdown {\n        width: calc(100vw - 2rem);\n        right: -1rem;\n        position: fixed;\n        top: 75px;\n        left: 1rem;\n    }\n\n    .mobile-bottom-nav {\n        display: flex !important;\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        background: #fff;\n        height: 72px;\n        border-top: 1px solid var(--border-color);\n        z-index: 1001;\n        padding: 0 0.5rem;\n        justify-content: space-around;\n        align-items: center;\n        box-shadow: 0 -4px 25px rgba(0, 0, 0, 0.12);\n    }\n\n    .bottom-nav-item {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 4px;\n        text-decoration: none;\n        color: var(--text-secondary);\n        font-size: 0.65rem;\n        font-weight: 600;\n        flex: 1;\n        text-align: center;\n    }\n\n    .bottom-nav-item .nav-icon {\n        font-size: 1.5rem;\n        margin-bottom: 2px;\n    }\n\n    .bottom-nav-item.active {\n        color: var(--primary-color);\n    }\n\n    .modal-content {\n        padding: 1.5rem;\n    }\n}\n\n/* Table Responsiveness Utility */\n@media (max-width: 900px) {\n\n    .disbursement-table,\n    .responsive-table {\n        border: none !important;\n    }\n\n    .disbursement-table .table-header,\n    .responsive-table .table-header {\n        display: none !important;\n    }\n\n    .disbursement-table .table-row,\n    .responsive-table .table-row {\n        grid-template-columns: 1fr !important;\n        padding: 1.5rem !important;\n        margin-bottom: 1.5rem;\n        border: 1px solid var(--border-color) !important;\n        border-radius: 20px !important;\n        background: #fff !important;\n        box-shadow: var(--shadow-sm);\n    }\n\n    .disbursement-table .table-cell,\n    .responsive-table .table-cell {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0.8rem 0 !important;\n        border-bottom: 1px solid #f0f0f0 !important;\n    }\n\n    .disbursement-table .table-cell:last-child {\n        border-bottom: none !important;\n    }\n\n    .disbursement-table .cell-label {\n        display: block !important;\n        font-weight: 700;\n        font-size: 0.7rem;\n        color: #999;\n        text-transform: uppercase;\n    }\n\n    .disbursement-table .cell-value {\n        font-weight: 600;\n        font-size: 0.95rem;\n    }\n}\n\n.mobile-bottom-nav {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
